import { useIntl } from "react-intl";

const Policy = () => {
  const { sav_form } = useIntl().messages;

  return (
    <>
      <h2>{sav_form.policy.title}</h2>
      <h3>{sav_form.policy.subtitle}</h3>
      <p>
        <strong>{sav_form.policy.intro.title}</strong>
      </p>
      <p>{sav_form.policy.intro.paragraph}</p>
      <p>
        <strong>{sav_form.policy.defect.title}</strong>
      </p>
      <p>{sav_form.policy.defect.paragraph}</p>
      <ul>
        {sav_form.policy.defect.list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p>{sav_form.policy.defect.paragraph_2}</p>
      <ul>
        {sav_form.policy.defect.list_2.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p>{sav_form.policy.defect.paragraph_3}</p>
      <ul>
        {sav_form.policy.defect.list_3.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p>
        <strong>{sav_form.policy.usage.title}</strong>
      </p>
      <p>
        <u>{sav_form.policy.usage.year}</u>
      </p>
      <p>
        <u>{sav_form.policy.usage.website.title}</u>
      </p>
      {sav_form.policy.usage.website.paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
      <p>
        <u>{sav_form.policy.usage.dealer.title}</u>
      </p>
      <p>{sav_form.policy.usage.dealer.paragraph}</p>
      <p>
        <strong>{sav_form.policy.old_purchase.title}</strong>
      </p>
      <p>{sav_form.policy.old_purchase.paragraph}</p>
    </>
  );
};

export default Policy;
